export default __webpack_public_path__ + "static/media/gs-8.b5286a93.png";